module.exports = __webpack_public_path__ + "img/profil.520e8a31.svg";